import { jsxs as t, jsx as a } from "react/jsx-runtime";
import d from "../Icons/Add.js";
import p from "../Icons/Change.js";
import f from "../Icons/Close.js";
import n from "../Icons/Delete.js";
import c from "../Icons/Download.js";
import { TaskButtonWrapper as u, TextWrapper as N, TaskButtonIconWrapper as W } from "./styled.js";
const C = ({
  disabled: s,
  children: m,
  iconType: r,
  styleType: e,
  onClick: o = () => {
  },
  ...l
}) => /* @__PURE__ */ t(
  u,
  {
    disabled: s,
    $styleType: e,
    onClick: o,
    ...l,
    children: [
      r && /* @__PURE__ */ t(W, { children: [
        r === "add" && /* @__PURE__ */ a(d, { className: r }),
        r === "change" && /* @__PURE__ */ a(p, { className: r }),
        r === "delete" && /* @__PURE__ */ a(n, { className: r }),
        r === "download" && /* @__PURE__ */ a(c, { className: r }),
        r === "cancel" && /* @__PURE__ */ a(f, { className: r })
      ] }),
      /* @__PURE__ */ a(N, { children: m })
    ]
  }
);
export {
  C as TaskButton,
  C as default
};
